import { TRefundsRow } from 'redux/reducers/refunds/types';
import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { DATES, DATES_ID } from 'services/constants/dates';

const DATE_FILTER: [string, string][] = [
	[DATES_ID.TODAY, DATES.TODAY],
	[DATES_ID.YESTERDAY, DATES.YESTERDAY],
	[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
	[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
	[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
	[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
	[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
	[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
	[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
	[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
	[DATES_ID.CUSTOM_RANGE_PAST, DATES.CUSTOM_RANGE],
];

export const refundsStructure: TTableStructure<keyof TRefundsRow, TRefundsRow>[] = [
	/**
	 * Hidden column that makes a click on the row open the refund page:
	 * `EasRow` resolves the row link from the first column of the `LINK` type.
	 */
	{
		name: 'Refund ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EAS Order ID',
		selector: 'orderId',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		searchInfoText:
			"The search will be conducted based on a full match with the EAS order ID or a partial match with the store's order number.",
		colSpan: 1,
		type: ETableStructureType.OPEN_IN_NEW_TAB,
		link: (item: TRefundsRow) => (item?.orderId ? `/order/${item.orderId}` : null),
		tooltip: 'Open the order in a new tab',
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Store Order #',
		selector: 'externalOrderId',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Order Paid At',
		selector: 'orderPaymentDate',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Refund Created At',
		selector: 'returnCreateDate',
		show: true,
		sortable: true,
		filterable: true,
		filter: DATE_FILTER,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Products Amount Refunded',
		selector: 'totalMerchReturned',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: (item: TRefundsRow) => item?.paymentCurrency ?? 'EUR',
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Shipping Amount Refunded',
		selector: 'totalDeliveryReturned',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: (item: TRefundsRow) => item?.paymentCurrency ?? 'EUR',
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'VAT Amount Refunded',
		selector: 'totalVatReturned',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: (item: TRefundsRow) => item?.paymentCurrency ?? 'EUR',
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Total Amount Refunded',
		selector: 'totalReturnAmount',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		currency: (item: TRefundsRow) => item?.paymentCurrency ?? 'EUR',
		align: ETableStructureAlign.RIGHT,
	},
];
